import axios from "axios";
import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiEye, FiCheck } from "react-icons/fi";
import moment from "moment/moment";
import DataTable from "react-data-table-component";
import { api, endpoint } from "../../api";
import { DatePicker,  Spin } from "antd";
import { useSelector } from "react-redux";
import Search from "antd/es/input/Search";
import ReactToPdf from "react-to-pdf";

import { CSVLink } from "react-csv";
import appConfig from "../../appConfig";


const { RangePicker } = DatePicker;

const AlarmHistory = () => {
    const userDetails = useSelector((state) => state?.user?.userDetails);

    const pdfRef = React.createRef();

    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [11.69, 8.27]
    };

    const [notifications, setNotifications] = useState([]);
    const [notificationList, setNotificationList] = useState([]);
    const [siteLocations, setSiteLocations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState({
        site: '',
        from: '',
        to: '',
    })

    const { site, from, to } = filter

    const onInputChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    const onSearch = e => {
        const text = e.target.value
        setSearch(text)
        const result = notificationList?.filter(notification => notification.name.toLowerCase().includes(text.toLowerCase()))
        setNotifications(result)
    }

    const getNotifications = async () => {
        setIsLoading(true);
        try {
            let { results, count } = await api.get(endpoint.notification, {
                params: { limit, page, sortBy: "date", orderBy: "DESC" },
            });

            setNotifications(results);
            setNotificationList(results);
            setTotal(count || 0);
        } catch (error) { }
        setIsLoading(false);
    };

    const getSiteLocations = async (userDetails) => {
        if (userDetails.role === "superAdmin") {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/site-location`, { withCredentials: true });
            if (response) {
                setSiteLocations(response.data.sort((a, b) => (a?.createdAt < b?.createdAt ? 1 : -1)));
            }
        } else if (userDetails.role === "admin") {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/site-location/admin-sites/` + userDetails._id,
                { withCredentials: true }
            );
            if (response) {
                setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
            }
        } else if (userDetails.role === "installer") {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/site-location/installer-sites/` + userDetails._id,
                { withCredentials: true }
            );
            if (response) {
                setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
            }
        } else if (userDetails.role === "user") {
            let site = [];
            site.push(userDetails.site);
            setSiteLocations(site);
        } else if (userDetails.role === "public") {
            let site = [];
            site.push(userDetails.site);
            setSiteLocations(site);
        }
    };

    useEffect(() => {
        getSiteLocations(userDetails)
    }, [userDetails])

    useEffect(() => {
        document.title = `${appConfig.name} - System Alarm History`;
        getNotifications();
    }, [page, limit]);

    const columns = [
        {
            name: "No.",
            cell: (row, index) => (page - 1) * limit + index + 1,
            width: "60px",
            center: true,
        },
        {
            name: "Alarm Name",
            cell: (row) => <div>{row?.name}</div>,
        },
        {
            name: "Site Location",
            cell: (row) => <>{row?.site?.name}</>,
            selector: (row) => row?.site,
        },
        {
            name: "Device Name",
            cell: (row) => row?.device?.name,
            width: "150px",
        },
        {
            name: "Device Parameter",
            cell: (row) => row?.parameter?.name,
        },
        {
            name: "Trigger Status",
            // cell: (row) => row?.parameter?.name,
        },
        {
            name: "Trigger Value",
            // cell: (row) => row?.parameter?.name,
        },
        {
            name: "Timestamp",
            selector: (row) => moment(row?.device?.createdAt).format("DD/MM/YYYY"),
        },
        {
            name: "Action",
            cell: (row) => (
                <div>


                    <Button className='mx-2' variant='warning'> <FiCheck /> </Button>
                    {/* <Button className='mx-2' variant='danger'> <FiCheck/> </Button>
                    <Button className='mx-2' variant='success'> Verified </Button> */}

                    <Link to={`/alarm-view/` + row?._id} title='View Alarm' className="btn btn-success me-1">
                        <FiEye />
                    </Link>
                </div>
            ),
            width: '150px',
            center: "yes",
        },
    ];

    const cvsData = notifications.length > 0 ? notifications.map((data, ind) => ({
        No: ind + 1,
        'Alarm Name': data.name,
        'Site Location': data?.site?.name,
        'Device Name': data?.device?.name,
        'Trigger Status': '',
        'Trigger value': '',
        'Timestamp': moment(data?.device?.updatedAt).format("DD/MM/YYYY"),
        'Time Range': `${from} - ${to}`,

    })) : []

    console.log({ cvsData })


    return (
        <div className="settings">
            <div className="card p-3 m-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <label className="az-content-label">Manage Alarm</label>
                        <span className="d-block py-2">System Alarm History</span>
                    </div>
                    <div className="col-md-4 d-flex justify-content-end p-0">
                        <Link className="btn btn-az-primary btn-md" to="/create-alarm">Create New Alarm</Link>
                    </div>
                </div>
                <hr className="mt-0" />

                {/* filter */}
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="site" className="form-label">
                            Select A Site Location
                        </label>
                        <select name="site" id="site" value={site} className="form-select" onChange={onInputChange}>
                            <option value="" disabled>
                                Select A Site Location
                            </option>
                            {siteLocations &&
                                siteLocations.length > 0 &&
                                siteLocations.map((item, index) => (
                                    <option value={item._id} key={index}>
                                        {item.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="site" className="form-label">
                            Select Date | Time
                        </label>
                        <RangePicker
                            presets={{ label: 'date' }}
                            className='w-100'
                            showTime={{ format: 'HH:mm' }}
                            placeholder={['Select Start Date | Time', 'Select End Date | Time']}
                            format="YYYY-MM-DD HH:mm"
                            onChange={(e, dateString) => {
                                setFilter({ from: dateString[0] });
                                setFilter({ to: dateString[1] });
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="site" className="form-label">
                            Search
                        </label>
                        <Search
                            size="large"
                            onChange={onSearch}
                            placeholder="Search Alarms"
                            value={search}
                        />
                    </div>
                </div>
                <hr />
                <Spin spinning={isLoading}>

                    <div className="d-flex">
                        <CSVLink
                            data={cvsData}
                            filename={`AlarmHistory-${new Date().getTime()}`}
                            className="ms-auto btn btn-primary me-2"
                            target="_blank"
                        >
                            Download CSV
                        </CSVLink>

                        <ReactToPdf targetRef={pdfRef} filename="div-blue.pdf" options={options} y={.5} x={.5} scale={0.9}>
                            {({ toPdf }) => (
                                <button className='btn btn-success me-2' onClick={() => {
                                    toPdf()
                                }}> Download PDF </button>
                            )}
                        </ReactToPdf>
                    </div>

                    <div>
                        <DataTable
                            noDataComponent={isLoading ? "Loading" : "No record found."}
                            columns={columns}
                            data={notifications}
                            pagination
                            paginationServer
                            paginationTotalRows={total}
                            paginationPerPage={limit}
                            onChangePage={(data) => {
                                setPage(data);
                            }}
                            onChangeRowsPerPage={(data) => {
                                setLimit(data);
                                setPage(1);
                            }}
                            paginationRowsPerPageOptions={[10, 20, 50]}
                        />
                    </div>


                    <div style={{ position: 'absolute', top: '0', left: '0', right: '0', zIndex: '-9999' }}>
                        <div ref={pdfRef} style={{ width: '11.69in' }}>

                            <DataTable
                                noDataComponent={isLoading ? "Loading" : "No record found."}
                                columns={columns}
                                data={notifications}
                                pagination
                                paginationServer
                                paginationTotalRows={total}
                                paginationPerPage={limit}
                                onChangePage={(data) => {
                                    setPage(data);
                                }}
                                onChangeRowsPerPage={(data) => {
                                    setLimit(data);
                                    setPage(1);
                                }}
                                paginationRowsPerPageOptions={[10, 20, 50]}
                            />
                        </div>
                    </div>
                </Spin>
            </div>
        </div>

    );
};

export default AlarmHistory;
